import React from 'react';

const Logo = ({ size = 32 }) => (
  <img src="/PNG/Pin2Point_Blue_font.png" alt="Pin2Point Logo" style={{ width: size, height: 'auto' }} />
);

export default Logo; 